import React, {FC, useEffect, useState} from 'react';
import { TopicLineJsonConfig } from "../../types";
import AvTopicLineContent from "./avTopicLineContent/AvTopicLineContent";


interface TopicProps {
  config: TopicLineJsonConfig;
}

const AvTopicLine: FC<TopicProps>  = ({config}) => {
  const {
    headline,
    text,
    topicImage,
    backBtnLabel,
    topicContent
  } = config;
  const [active, setActive] = useState(false);
  const [onlyText,setOnlyText] = useState('');

  const toggleBtn = (e: any) => {
    setActive(!active);
    e.preventDefault();
  };

  useEffect(() => {
    setOnlyText(topicImage?.imageUrl ? '' : 'full-width');
  });

  return (
    <>
      <div className="av-topic-line">
        <div className="av-topic-line__box">
          <div className="av-topic-line__wrapper">
            { topicImage?.imageUrl &&
              <div className="av-topic-line__img-container">
                <img className="av-topic-line__image" src={topicImage.imageUrl} alt={topicImage.altText}/>
              </div>
            }
            <div className={`av-topic-line__text-container ${onlyText}`}>
              <a className="topic-headline"
                 href="#" onClick={(e) => toggleBtn(e)}>
                <h2 className="hl-3">
                  {headline}
                </h2>
              </a>
              <p className="text tx-1" dangerouslySetInnerHTML={{ __html: text || '' }} />
            </div>
          </div>
          <button
            type='button'
            className="av-topic-line__button button-focus"
            onClick={toggleBtn}
            aria-expanded={active}
            aria-label={headline}
          >
            <span className={`${active ? 'ic-minus ' : 'ic-plus'}`} />
          </button>
        </div>
        {active &&
          <AvTopicLineContent backBtnLabel={backBtnLabel}  closeLayer={toggleBtn} topicContent={topicContent}/>
        }
      </div>
    </>
  );
};

export default AvTopicLine;
